/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';
import React from 'react';
import { Skeleton } from 'antd';

export default function LoadingExtension() {
  return (
    <div className="relative !z-0 h-screen">
    <div style={{"padding":"10px","display":"flex","paddingTop":"0px","paddingLeft":"38px","paddingRight":"38px","paddingBottom":"50px","width":"100%","flexDirection":"column","overflowY":"auto","overflowX":"hidden","gap":"12px","height":"100%"}}>
      <div style={{"display":"flex","flexDirection":"row","paddingTop":"20px","paddingBottom":"20px","height":"100px","justifyContent":"space-between","alignItems":"center"}}>
        <div style={{"display":"flex","flexDirection":"row","paddingTop":"5px","paddingLeft":"5px","paddingRight":"5px","paddingBottom":"5px"}}>
          <Skeleton.Button active={true} rootClassName="!text-[#10141A] !text-[40px]" />
        </div>
        <Skeleton.Button active={true} rootClassName="!rounded-[60px]" />
      </div>
      <Skeleton active={true} block={true} rootClassName="!w-full" />
    </div>
    </div>
  );
}
